<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible1"
        :close-on-click-modal="false"
        :modal="false"
        :title="customer.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="700px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="customer"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="省市区">
              <vm-district-select v-model="customer.areaId"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="街道">
              <el-select v-model="customer.streetName" clearable placeholder="请选择">
                <el-option
                    v-for="item in lastDistrict"
                    :key="item.districtID"
                    :label="item.districtName"
                    :value="item.districtName"
                    @click.native="selectLastDistrictName(item)"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="详细地址" prop="addressDetail">
          <el-input v-model="customer.addressDetail"/>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="customer.contact" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="customer.telephone" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="默认地址">
          <el-radio-group v-model="customer.isDefault">
            <el-radio :label="false">否</el-radio>
            <el-radio :label="true">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="customer.note" type="textarea" placeholder="请输入"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible1=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="getIsDefault">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  // import regular from "@/util/regular";
  import VmDistrictSelect from "@/components/VmDistrictSelect";
  //const storage = window.localStorage;
  export default {
    name:"CustomerAddressEdit",
    components: {VmDistrictSelect},
    data() {
      return {
        dialogVisible1: false,
        contentLoading: false,
        submitLoading: false,
        districtList: [],
        lastDistrict: [],
        isDefaultList: [],
        value: [],
        customer: {
          pkid:"",
          customerId: "",
          streetId: 0,//街道id
          areaId: 0,//区域id
          districtId: 0,//街道id
          customerName: "",
          addressName: "",
          streetName: "",
          ids: [],
          addressDetail: "",
          contact: "",
          telephone: "",
          note: "",
          isDefault:false,
          isDeleted: "",
        },
        ruleValidate: {
          // areaId: {required: true, message: "不能为空",trigger: "blur"},
          addressDetail: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    watch:{
      "customer.areaId": {
        deep: true,
        handler: function(newVal,oldVal) {
          if (newVal!==oldVal) {
            if (oldVal!==0) {
              this.customer.streetName = "";
              this.customer.streetId = "";
            }
            this.getLastDistrict(newVal);
          }
        },
      },
    },
    methods: {
      open(id,customerId) {
        this.customer.pkid = id;
        this.customer.customerId = customerId;
        this.dialogVisible1 = true;
        //this.getDistrictList();
        if(id>0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `customerDeliveryAddress/${this.customer.pkid}`)
          .then(resp => {
            console.log(resp);
            Object.assign(this.customer, resp);
            console.log(this.customer);
            this.getLastDistrict(this.customer.streetId);
          });
      },
      getLastDistrict(id) {
        console.log(id);
        if (id>0) {
          this.contentLoading = true;
          this.$http
            .get("basic", `districts/getDistrictListByParentId/${id}`)
            .then(resp => {
              this.lastDistrict = resp;
              this.contentLoading = false;
            }).catch(() => {
              this.contentLoading = false;
              this.$message.error("获取街道数据失败");
            });
        }
      },
      selectLastDistrictName(item) {
        console.log(item);
        this.customer.streetName = item.districtName;
        this.customer.streetId = item.districtID;
      },
      getIsDefault() {
        //判断默认地址是否存在
        if (this.customer.isDefault) {
          this.$http
            .get("basic", `customerDeliveryAddress/isDefault/${this.customer.customerId}`)
            .then(resp => {
              this.isDefault = resp;
              console.log(this.isDefault);
            });
          if (this.isDefault && this.isDefault.pkid!==this.customer.pkid) {
            this.$confirm(" 默认地址已存在是否要替换?", "提示", {type: "warning"}).then(() => {
              this.handleSubmit();
            });
          }
          else {
            this.handleSubmit();
          }
        }else {
          this.handleSubmit();
        }
      },
      handleSubmit() {
        // if (this.customer.areaId <=0) {
        //   return this.$message.error("省市区不可为空");
        // }
        console.log(this.customer);
        if (this.customer.streetName === "" || this.customer.streetName==null) {
          this.customer.streetId = 0;
        }
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "customerDeliveryAddress", this.customer)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible1 = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss">
  .col{
    .el-select{
      width: 60%;
    }
  }
  .col:last-child{
    .el-select{
      width: 72%;
      input{
        padding-right: 25px;
      }
    }
  }
</style>
